function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2017, 2020. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
import PropTypes from 'prop-types';
import React from 'react';
import '../../scss/common/_msg.scss';
var Msg = /*#__PURE__*/function (_React$Component) {
  function Msg() {
    _classCallCheck(this, Msg);
    return _callSuper(this, Msg, arguments);
  }
  _inherits(Msg, _React$Component);
  return _createClass(Msg, [{
    key: "getFormattedKey",
    value: function getFormattedKey(key) {
      var isRange = /\-/.test(key),
        trimmed = key.replace(/^\{/, '').replace(/}$/, ''),
        split = isRange ? trimmed.split(/\-/) : trimmed.split(/\,/);
      if (isRange) {
        return {
          isRange: true,
          start: parseInt(split[0]),
          end: parseInt(split[split.length - 1])
        };
      }
      var arr = split.map(function (element) {
        return parseInt(element);
      });
      return {
        isRange: false,
        indexes: arr
      };
    }
  }, {
    key: "getKeyReplacementArray",
    value: function getKeyReplacementArray(formattedKey) {
      var arr = [];
      if (formattedKey.isRange) {
        for (var i = formattedKey.start; i <= formattedKey.end; i++) {
          arr.push('{' + i + '}');
        }
      } else {
        arr = formattedKey.indexes.map(function (index, i) {
          return '{' + index + '}';
        });
      }
      return arr;
    }
  }, {
    key: "sortReplacementArray",
    value: function sortReplacementArray(arr) {
      return arr.slice(0).sort(function (a, b) {
        var trimmedA = a.replace(/^\{/, '').replace(/\}$/, ''),
          trimmedB = b.replace(/^\{/, '').replace(/\}$/, '');
        if (trimmedA < trimmedB) {
          return -1;
        } else if (trimmedA > trimmedB) {
          return 1;
        }
        return 0;
      });
    }
  }, {
    key: "getErrors",
    value: function getErrors(text) {
      var formatted,
        regex,
        errors = [];
      for (var key in this.props.args) {
        formatted = this.getFormattedKey(key);
        if (formatted.isRange) {
          regex = new RegExp('\\{' + formatted.start + '\\}');
          if (!regex.test(text)) {
            errors.push(formatted.start);
          }
          regex = new RegExp('\\{' + formatted.end + '\\}');
          if (!regex.test(text)) {
            errors.push(formatted.end);
          }
        } else {
          errors = errors.concat(formatted.indexes.map(function (index) {
            regex = new RegExp('\\{' + index + '\\}');
            if (!regex.test(text)) {
              return index;
            }
          }).filter(function (index) {
            return index !== undefined;
          }));
        }
      }
      errors.sort();
      return errors;
    }
  }, {
    key: "getData",
    value: function getData() {
      var formatted,
        replacementArray = [],
        regexArr = [],
        indexesRegex;
      for (var key in this.props.args) {
        formatted = this.getFormattedKey(key);
        if (formatted.isRange) {
          regexArr.push('\\{' + formatted.start + '\\}.*\\{' + formatted.end + '\\}');
        } else {
          indexesRegex = formatted.indexes.map(function (index) {
            return '\\{' + index + '\\}';
          }).join('');
          regexArr.push(indexesRegex);
        }
        replacementArray = replacementArray.concat(this.getKeyReplacementArray(formatted));
      }
      replacementArray = this.sortReplacementArray(replacementArray);
      var regex = new RegExp('(' + regexArr.join(')|(') + ')'),
        bundleMsg = this.props.bundle.get(this.props.bundleKey, replacementArray, this.context.locale);
      var errors = this.getErrors(bundleMsg);
      var splitMsg = bundleMsg.split(regex).filter(function (element) {
        return typeof element === 'string' && replacementArray.indexOf(element) === -1 && !regexArr.find(function (regexElement) {
          return regexElement.replace(/\\/g, '') === element;
        });
      });
      return {
        msg: splitMsg,
        errors: errors
      };
    }
  }, {
    key: "isTextRange",
    value: function isTextRange(string) {
      return /^\{\d\}.*\{\d\}$/.test(string);
    }
  }, {
    key: "isKeyRange",
    value: function isKeyRange(key) {
      return /\-/.test(key);
    }
  }, {
    key: "getRangeText",
    value: function getRangeText(range) {
      return range.replace(/\{\d\}/g, '');
    }
  }, {
    key: "insertRangeText",
    value: function insertRangeText(element, text) {
      var clonedElement;
      if (_typeof(element) === 'object' && element.props && element.props.children) {
        clonedElement = /*#__PURE__*/React.cloneElement(element, {
          children: this.insertRangeText(element.props.children, text)
        });
      } else if (element === '$text') {
        return text;
      }
      return clonedElement || element;
    }
  }, {
    key: "getInjected",
    value: function getInjected() {
      var data = this.getData(),
        splitMsg = data.msg,
        errors = data.errors,
        keys = Object.keys(this.props.args),
        keyCount = 0,
        arr = [];
      if (!errors.length) {
        for (var i = 0; i < splitMsg.length; i++) {
          if (this.isTextRange(splitMsg[i])) {
            arr.push(this.insertRangeText(this.props.args[keys[keyCount++]], this.getRangeText(splitMsg[i])));
          } else if (this.isKeyRange(keys[keyCount])) {
            arr.push(splitMsg[i]);
          } else {
            arr.push(splitMsg[i]);
            if (keyCount < keys.length) {
              arr.push(this.props.args[keys[keyCount++]]);
            }
          }
        }
      } else {
        for (var i = 0; i < errors.length; i++) {
          arr.push('{!' + errors[i] + '!}');
        }
      }
      return arr;
    }
  }, {
    key: "render",
    value: function render() {
      var parts = this.getInjected();
      return /*#__PURE__*/React.createElement("span", {
        className: "msg"
      }, function () {
        return parts.map(function (part, i) {
          return typeof part === 'string' ? part : /*#__PURE__*/React.cloneElement(part, {
            key: i
          });
        });
      }());
    }
  }]);
}(React.Component);
export { Msg as default };
Msg.contextTypes = {
  locale: PropTypes.string
};
Msg.propTypes = {
  bundleKey: PropTypes.string.isRequired,
  args: PropTypes.object.isRequired,
  bundle: PropTypes.object.isRequired
};